'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/react-reconciler.production.min.js');
} else {
  module.exports = require('./cjs/react-reconciler.development.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/react-reconciler/index.js
// module id = 1070
// module chunks = 0